// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3SXof","title":"InfoRow_title__27TZ8"};